import React from 'react';
import { TextItalic } from '@good/icons';

import { useRichTextEditor } from '../rich-text-editor-context';
import { MenuButton } from './menu-button';

export const ItalicButton = () => {
  const { editor, disabled } = useRichTextEditor();

  const isDisabled = disabled || !editor.can().chain().focus().toggleItalic().run();
  const onClick = () => editor.chain().focus().toggleItalic().run();
  const variant = editor.isActive('italic') ? 'filled' : 'transparent';

  return (
    <MenuButton onClick={onClick} disabled={isDisabled} variant={variant} aria-label='italic'>
      <TextItalic />
    </MenuButton>
  );
};
